import { SiteFooter, SiteHeader } from "../components/site-header";

const references = [
  [
    "Dark Triad Dirty Dozenの測定上の論点",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC4782707/",
  ],
  [
    "日本語版Dark Triad Dirty Dozenの信頼性・妥当性",
    "https://cir.nii.ac.jp/crid/1390282680190261632?lang=en",
  ],
  [
    "HEXACO Honesty–Humility",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC9047109/",
  ],
  ["シニシズムの縦断研究", "https://pmc.ncbi.nlm.nih.gov/articles/PMC5753841/"],
  ["Moral Grandstanding", "https://pmc.ncbi.nlm.nih.gov/articles/PMC6795490/"],
  [
    "オンライン・シェイミングの関連要因",
    "https://pmc.ncbi.nlm.nih.gov/articles/PMC10035748/",
  ],
  [
    "成人期の性格変化に関する縦断研究",
    "https://pubmed.ncbi.nlm.nih.gov/21707197/",
  ],
  [
    "Cloudflare Workers Static Assetsの推奨構成",
    "https://developers.cloudflare.com/workers/best-practices/workers-best-practices/",
  ],
  [
    "Cloudflare Workers Static Assetsの料金",
    "https://developers.cloudflare.com/workers/static-assets/billing-and-limitations/",
  ],
  [
    "Cloudflare D1料金",
    "https://developers.cloudflare.com/d1/platform/pricing/",
  ],
  [
    "個人情報保護委員会 ガイドライン",
    "https://www.ppc.go.jp/personalinfo/legal/",
  ],
] as const;

export function AboutRoute() {
  return (
    <div className="site-shell">
      <SiteHeader />
      <main className="document-page">
        <header className="document-page__header">
          <p className="eyebrow">ABOUT THE CHECK</p>
          <h1>この診断について</h1>
          <p>
            「前より性格が悪くなったかも」を、行動の変化から眺め直すためのセルフチェックです。
          </p>
        </header>
        <section aria-labelledby="method-heading">
          <h2 id="method-heading">診断の考え方</h2>
          <p>
            Dark
            Triad、HEXACOのHonesty–Humility、共感性、シニシズム、心理的特権意識、道徳的誇示、道徳的不活性化、オンライン脱抑制などの関連概念を設計の参考にしています。
          </p>
          <p>
            一方で、既存尺度の設問は転載していません。日本語の日常行動に置き換えて独自に作成したオリジナル尺度であり、検証済み心理尺度や科学的診断を称するものではありません。
          </p>
        </section>
        <section aria-labelledby="structure-heading">
          <h2 id="structure-heading">4領域・8パターン</h2>
          <p>
            他者への温度、力と利得、認知と責任、表出と制裁の4領域を、共感摩耗から正義マウントまで8つの行動パターンに分けます。現在傾向と1〜2年前からの自己申告上の変化は別に扱います。
          </p>
        </section>
        <section aria-labelledby="references-heading">
          <h2 id="references-heading">参考資料</h2>
          <ul className="reference-list">
            {references.map(([label, href]) => (
              <li key={href}>
                <a href={href} target="_blank" rel="noopener noreferrer">
                  {label}
                  <span aria-hidden="true"> ↗</span>
                </a>
              </li>
            ))}
          </ul>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}
